// AdminPanel.jsx

import React, { useEffect, useState } from "react";
import axios from "axios";
import "./panel.css";
import { HostApi } from "../../configuration";

const AdminPanel = () => {

  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {

    const res = await axios.get(`${HostApi()}/api/Advisor/getservice`
    );

    setData(res.data);
  };

  const updateStatus = async (id, status) => {

    await axios.put(`${HostApi}/api/ServiceRequest/${id}`,
      {
        status
      }
    );

    fetchData();
  };

  return (
    <div className="admin-panel">

      <h1>Service Requests</h1>

      <table border="1" cellPadding="10">

        <thead>
          <tr>
            <th>Name</th>
            <th>Phone</th>
            <th>Email</th>
            {/* <th>Service</th> */}
            <th>Message</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>

          {data.map((item) => (
            <tr key={item.id}>

              <td>{item.name}</td>
              <td>{item.phone}</td>
              <td>{item.email}</td>
              {/* <td>{item.serviceName}</td> */}
              <td>{item.msg}</td>
              <td>{item.status}</td>

              <td>
 
                <select
                  value={item.status}
                  onChange={(e) =>
                    updateStatus(item.id, e.target.value)
                  }
                >
                  <option>Pending</option>
                  <option>In Process</option>
                  <option>Done</option>
                </select>

              </td>

            </tr>
          ))}

        </tbody>

      </table>

    </div>
  );
};

export default AdminPanel;